import { forwardRef } from 'react';
import { DatePicker, DatePickerProps } from './DatePicker';
import { Rfi } from '../sdk';
import { useDueDateTimezone } from '../hooks';

export type DueDatePickerProps = { rfiCreatedAt: Rfi['createdAt'] } & DatePickerProps;

export const DueDatePicker = forwardRef<HTMLDivElement, DueDatePickerProps>(
  ({ rfiCreatedAt, ...datePickerProps }, ref) => {
    const { dueDateTimeZone } = useDueDateTimezone(rfiCreatedAt);

    return (
      <DatePicker
        ref={ref}
        {...(dueDateTimeZone && { timeZone: dueDateTimeZone })}
        {...datePickerProps}
      />
    );
  },
);
